module.exports = __webpack_public_path__ + "static/img_1.24c65c0e.jpg";